import { confirmDialog } from "primereact/confirmdialog";

const useEditorNavigation = ({
  navigate,
  location,
  headerData,
  fetchHeader,
  saveHeader,
}) => {
  // handle UI event section

  const handleOnClickBack = () => {
    const accept = async () => {
      const urlParams = new URLSearchParams(location.search);
      const key = urlParams.get("key");
      if (key) {
        navigate(`../..?key=${encodeURIComponent(key)}`);
      } else {
        navigate("../..");
      }
    };

    const reject = () => {};

    confirmDialog({
      message: `Menutup bon ini, lanjutkan?`,
      header: "Konfirmasi ",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      acceptLabel: "Konfirmasi",
      rejectLabel: "Tidak",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  const handleOnClickReload = () => {
    fetchHeader(headerData.id);
  };

  const handleOnClickSaveHeader = () => {
    saveHeader();
  };

  return {
    handleOnClickBack,
    handleOnClickReload,
    handleOnClickSaveHeader,
  };
};

export default useEditorNavigation;
